import React from 'react'

const HistoryItemIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <mask id="mask0_4684_23450"  maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
            <rect width="16" height="16" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_4684_23450)">
            <path className='custom-icon' d="M2 13.3332V2.6665L14.6667 7.99984L2 13.3332ZM3.33333 11.3332L11.2333 7.99984L3.33333 4.6665V6.99984L7.33333 7.99984L3.33333 8.99984V11.3332Z" fill="#353C41"/>
        </g>
    </svg>
  )
}

export default HistoryItemIcon
